<script>
import {EventBus} from "@/EventBus";
import axios from "axios";

export default {
  name: 'GamePreviewCardXs',
  props: ['game', 'time'],
  data() {
    return {
      info: {
        id: '',
        imageUrl: '',
        gameType: '',
        gameUrl: '',
        name: '',
        gameId: '',
        makerId: '',
        makerUrl: '',
        makerName: '',
        genre: [],
        price: '',
        tags: [],
        date: '',
        ciEnUrl: '',
        ciEnAvatar: '',
        follow: false
      },
      blurR18: false,
      login: false,
      ageFlag: false,
      ageTag: '',
      displayImageUrl: '',
      objectUrl: null
    }
  },
  beforeMount() {
    this.login = localStorage.getItem('token') !== null
  },
  mounted() {
    EventBus.$on('changeState', () => {
      this.login = localStorage.getItem('token') !== null
    })
    EventBus.$on('timeline:blur', (val) => {
      this.blurR18 = val
    })
    this.info = this.game
    this.info.imageUrl = this.normalizeImageUrl(this.info.imageUrl)
    this.displayImageUrl = this.info.imageUrl
    if (this.game.saleDate === '未定') {
      this.info.date = this.time
    } else {
      this.info.date = this.game.saleDate
    }

    if (this.info.genre.length === 1 && this.info.genre[0] === '') {
      this.info.genre = []
    }

    if (this.info.tags.length === 1 && this.info.tags[0] === '') {
      this.info.tags = []
    }

    this.info.genre.forEach((genre) => {
      if (genre === '全年齢') {
        this.ageFlag = true;
        this.ageTag = '全年齢'
      } else if (genre === 'R-15') {
        this.ageFlag = true;
        this.ageTag = 'R-15'
      }
    })

    this.prepareImage()
  },
  beforeUnmount() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  },
  methods: {
    addFollow(id) {
      axios.post('/api/user/announce', {
        'id': id
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify.success({
            title: '收藏成功',
            message: '游戏已加入收藏'
          })
          this.info.follow = true
        } else if (res.data.code === 400) {
          this.$notify.warning({
            title: '你已经收藏过了',
            message: '请勿重复收藏'
          })
        } else if (res.data.code === 500) {
          this.$notify.error({
            title: '收藏失败',
            message: res.data.message
          })
        }
      })
    },
    removeFollow(id) {
      axios.delete('/api/user/announce', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        data: {
          'id': id
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify.success({
            title: '取消成功',
            message: '游戏已取消收藏'
          })
          this.info.follow = false
        } else if (res.data.code === 400) {
          this.$notify.warning({
            title: '你还没有收藏',
            message: '请勿重复取消'
          })
        } else if (res.data.code === 500) {
          this.$notify.error({
            title: '取消失败',
            message: res.data.message
          })
        }
      })
    },
    addBlacklist(id) {
      axios.post('/api/user/author/blacklist', {
        'id': id
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify.success({
            title: '加入黑名单成功',
            message: '已将该作者加入黑名单'
          })
          EventBus.$emit('refreshPreviewList')
        } else if (res.data.code === 400) {
          this.$notify.warning({
            title: '加入黑名单失败',
            message: res.data.message
          })
        } else if (res.data.code === 500) {
          this.$notify.error({
            title: '加入黑名单失败',
            message: res.data.message
          })
        }
      })
    },
    normalizeImageUrl(url) {
      if (!url) return ''
      return url.startsWith('//') ? 'https:' + url : url
    },
    async prepareImage() {
      const url = this.info.imageUrl
      if (!url) return

      if (!('caches' in window)) {
        this.displayImageUrl = url
        return
      }

      try {
        const cache = await caches.open('preview-image-cache')
        const cached = await cache.match(url)
        if (cached) {
          const blob = await cached.blob()
          this.setObjectUrl(blob)
          return
        }

        const response = await fetch(url, { mode: 'cors' })
        if (response.ok) {
          await cache.put(url, response.clone())
          const blob = await response.blob()
          this.setObjectUrl(blob)
          return
        }

        this.displayImageUrl = url
      } catch (e) {
        this.displayImageUrl = url
      }
    },
    setObjectUrl(blob) {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl)
      }
      this.objectUrl = URL.createObjectURL(blob)
      this.displayImageUrl = this.objectUrl
    }
  }
}
</script>

<template>
  <div>
    <el-card class="card">
      <el-image :src="displayImageUrl" size="small" class="sample-image" :class="{ 'r18-blur': blurR18 }"></el-image>
      <div>
        <h3 class="game-id">
          <span class="game-id-text">{{ info.gameId }}</span>
          <el-tag size="small">{{ info.gameType }}</el-tag>
          <div v-if="login" class="follow-actions">
            <el-button v-if="info.follow" size="small" type="danger" plain
                       @click="removeFollow(info.id)">取消收藏
            </el-button>
            <el-button v-else size="small" type="success" plain @click="addFollow(info.id)">
              加入收藏
            </el-button>
          </div>
        </h3>
        <h3 class="game-name"><a :href="info.gameUrl" target="_blank">{{ info.name }}</a></h3>
        <h4 class="maker">
          <a :href="info.makerUrl">{{ info.makerName }}</a>
          <span v-if="info.ciEnUrl">
              <el-divider direction="vertical"></el-divider>
              <el-avatar :src="info.ciEnAvatar" style="height: 16px; width: 16px"></el-avatar>
              <a :href="info.ciEnUrl" target="_blank"> Ci-en</a>
            </span>
          <el-link type="danger" style="margin-left: 10px" :underline="false" @click="addBlacklist(info.makerId)"
                   v-if="login">
            <font-awesome-icon icon="fa-solid fa-ban"/>
            加入黑名单
          </el-link>
        </h4>
        <div v-for="genre in info.genre" :key="genre" style="display: inline-block" class="genre">
          <el-tag size="mini" style="margin-right: 5px" type="danger" v-if="genre === '全年齢'">{{ genre }}</el-tag>
          <el-tag size="mini" style="margin-right: 5px" type="warning" v-else>{{ genre }}</el-tag>
        </div>
        <div style="font-weight: bold; font-size: 16px" class="price">
          <font-awesome-icon icon="fa-regular fa-calendar"/>
          {{ info.date }}
          <el-divider direction="vertical"></el-divider>
          <font-awesome-icon icon="fa-regular fa-credit-card"/>
          <span style="color: #F56C6C; "> {{ info.price }}</span>
        </div>
        <div v-for="tag in info.tags" :key="tag" style="display: inline-block" class="tag">
          <el-tag size="small" style="margin-right: 5px">{{ tag }}</el-tag>
        </div>
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.card {
  margin-bottom: 10px;
  border-radius: 10px;
}

.game-name {
  margin: 0;
}

.game-id {
  margin-top: 10px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.game-id-text {
  font-weight: bold;
}

.follow-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.r18-blur {
  filter: blur(3px);
  transition: filter 0.2s ease;
}

.maker {
  margin-top: 10px;
  margin-bottom: 20px;
}

.genre {
  margin-top: 10px;
}

.price {
  margin-top: 5px;
}

.tag {
  margin-top: 5px;
}

a {
  color: #409EFF;
  text-decoration: none;
}
</style>
